module.exports = __webpack_public_path__ + "static/img/logo.f937dc79.png";